import React from "react";

const BankInclusionStatCard = ({ header, items, loading = false }) => {
  if (loading) {
    return (
      <div className="stats-card">
        <div className="stats-item stats-card-header">
          <div className="skeleton skeleton-text skeleton-text--medium"></div>
        </div>
        {[...Array(4)].map((_, index) => (
          <div className="stats-item" key={index}>
            <div className="skeleton skeleton-text skeleton-text--large"></div>
            <div className="skeleton skeleton-text skeleton-text--small"></div>
          </div>
        ))}
      </div>
    );
  }

  return (
    <div className="stats-card">
      <div className="stats-item stats-card-header">
        <span className="stats-card-label">{header}</span>
      </div>
      {items.map((item, index) => (
        <div className="stats-item" key={index}>
          <span className="stats-label">
            {`${item.label}${
              item.percentage !== null ? ` (${item.percentage}%)` : ""
            }`}
          </span>
          <span className="stats-value">{item.value}</span>
        </div>
      ))}
    </div>
  );
};

export default BankInclusionStatCard;
